import React from "react";
import TextFormInput from "components/framework/forms/TextFormInput";
import { nameOf } from "services/util/ObjectUtil";
import CardSectionHeader from "components/framework/cards/CardSectionHeader";
import classnames from "classnames";
import { isEmail, isEmailOrUrl } from "services/util/StringUtil";
import { ServiceProviderProfile } from "services/apis/types/serviceProvider/ServiceProviderProfile";
import { ErrorHandler } from "services/customHooks/useErrors";
import { ProcessingTimeType } from "../types/ProcessingTimeType";
import DropdownFormService from "components/framework/forms/DropdownFormService";

type Props = {
  readonly: boolean;
  serviceProvider: ServiceProviderProfile;
  isRespOrgId: boolean;
  setServiceProvider: (serviceProvider: ServiceProviderProfile) => void;
  getErrorHandler: (key: string) => ErrorHandler;
};

export default function LnpInformation(props: Props) {
  const formatUrl = (link: string) => {
    const url = isEmail(link) ? `mailto:${link}` : link;

    return url;
  };

  const handleInputClick = (
    e: React.MouseEvent<HTMLInputElement, MouseEvent>
  ) => {
    if (props.readonly && isEmailOrUrl(e.currentTarget.value)) {
      window.open(formatUrl(e.currentTarget.value), "_blank");
    }
  };

  return (
    <>
      <CardSectionHeader labelTranslationId="tppModal.lnpInformation" />

      <div className="mb-3 d-flex">
        <div className="flex-grow-1 mr-2">
          {/* {!props.isRespOrgId && (
            <>
              <div className="d-flex flex-direction-column">
                <TextFormInput
                  inputClassName={classnames({
                    "cursor-pointer":
                      props.readonly &&
                      isEmailOrUrl(props.serviceProvider.lnpTppLocation),
                  })}
                  readonly={props.readonly}
                  labelTranslationId="tppModal.lsrLocation"
                  placeholderTranslationId="tppModal.lsrLocation.placeholder"
                  value={props.serviceProvider.lsrLocation}
                  required={!props.readonly && !props.isRespOrgId}
                  handleInputChange={(value: string) =>
                    props.setServiceProvider({
                      ...props.serviceProvider,
                      lsrLocation: value,
                    })
                  }
                  onClick={handleInputClick}
                  errorHandler={props.getErrorHandler(
                    nameOf<ServiceProviderProfile>("lsrLocation")
                  )}
                />
              </div>
              <div className="flex-grow-1">
                <div className="d-flex flex-direction-column">
                  <TextFormInput
                    inputClassName={classnames({
                      "cursor-pointer":
                        props.readonly &&
                        isEmailOrUrl(props.serviceProvider.lnpTppLocation),
                    })}
                    readonly={props.readonly}
                    labelTranslationId="tppModal.csrLocation"
                    placeholderTranslationId="tppModal.csrLocation.placeholder"
                    value={props.serviceProvider.csrLocation}
                    required={!props.readonly && !props.isRespOrgId}
                    handleInputChange={(value: string) =>
                      props.setServiceProvider({
                        ...props.serviceProvider,
                        csrLocation: value,
                      })
                    }
                    onClick={handleInputClick}
                    errorHandler={props.getErrorHandler(
                      nameOf<ServiceProviderProfile>("csrLocation")
                    )}
                  />
                </div>
              </div>
              <div className="flex-grow-1">
                <div className="d-flex flex-direction-column">
                  <TextFormInput
                    inputClassName={classnames({
                      "cursor-pointer":
                        props.readonly &&
                        isEmailOrUrl(props.serviceProvider.lnpTppLocation),
                    })}
                    readonly={props.readonly}
                    labelTranslationId="tppModal.lnpTppLocation"
                    placeholderTranslationId="tppModal.lnpTppLocation.placeholder"
                    value={props.serviceProvider.lnpTppLocation}
                    required={!props.readonly && !props.isRespOrgId}
                    handleInputChange={(value: string) =>
                      props.setServiceProvider({
                        ...props.serviceProvider,
                        lnpTppLocation: value,
                      })
                    }
                    onClick={handleInputClick}
                    errorHandler={props.getErrorHandler(
                      nameOf<ServiceProviderProfile>("lnpTppLocation")
                    )}
                  />
                </div>
              </div>
            </>
          )} */}
          <div className="flex-grow-1">
            <div className="d-flex flex-direction-column">
              <DropdownFormService
                disabled={props.readonly}
                required
                labelTranslationId="tppModal.processingTime"
                value={props.serviceProvider.lnpSpeed}
                handleInputChange={(value: string) =>
                  props.setServiceProvider({ ...props.serviceProvider, lnpSpeed: value })
                }
                errorHandler={props.getErrorHandler(nameOf<ServiceProviderProfile>("lnpSpeed"))}
                options={Object.keys(ProcessingTimeType).map((x) => {
                  return { key: x, value: ProcessingTimeType[x] };
                })}
              />
            </div>
          </div>
          <div className="flex-grow-1">
            <div className="d-flex flex-direction-column">
              <TextFormInput
                readonly={props.readonly}
                labelTranslationId="tppModal.lnpPhoneNumber"
                placeholderTranslationId="tppModal.lnpPhoneNumber.placeholder"
                value={props.serviceProvider.lnpPhoneNumber}
                required={!props.readonly && props.isRespOrgId}
                handleInputChange={(value: string) =>
                  props.setServiceProvider({
                    ...props.serviceProvider,
                    lnpPhoneNumber: value,
                  })
                }
                onClick={handleInputClick}
                errorHandler={props.getErrorHandler(
                  nameOf<ServiceProviderProfile>("lnpPhoneNumber")
                )}
              />
            </div>
          </div>
          <div className="flex-grow-1">
            <div className="d-flex flex-direction-column">
              <TextFormInput
                inputClassName={classnames({
                  "cursor-pointer":
                    props.readonly &&
                    isEmailOrUrl(props.serviceProvider.lnpEmail),
                })}
                readonly={props.readonly}
                labelTranslationId="tppModal.lnpEmail"
                placeholderTranslationId="tppModal.lnpEmail.placeholder"
                value={props.serviceProvider.lnpEmail}
                required={!props.readonly && props.isRespOrgId}
                handleInputChange={(value: string) =>
                  props.setServiceProvider({
                    ...props.serviceProvider,
                    lnpEmail: value,
                  })
                }
                onClick={handleInputClick}
                errorHandler={props.getErrorHandler(
                  nameOf<ServiceProviderProfile>("lnpEmail")
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
